<template>
  <div>
    <div class="col-md-6">
      <card class="card" title="Register your application">
        <div class="row">
          <p>
            You can authorize your own Website or Application. OAuth applications are used to access the VividLeaf API.
          </p>
          <br />
          <p>Then add Access Token for each registered application</p>
          <br />
        </div>

        <div class="row">
          <div class="col">
            <h5>Applications List:</h5>
          </div>
        </div>

        <div v-if="loading" class="row">
          <div class="col">
            <MoonLoader class="loading"></MoonLoader>
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <paper-table :data="clients" :columns="tableColumns" type="hover" @clicked="showClient($event)">
            </paper-table>
          </div>
        </div>

        <div class="row text-center">
          <div class="col">
            <router-link to="/settings/applications/create">
              <p-button type="success"> Register a new application </p-button>
            </router-link>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import PaperTable from '@/components/PaperTable';
import CompanyCustomClientController from '@/controllers/PublicData/CompanyCustomClientController';
export default {
  name: 'Applications',
  components: { PaperTable, MoonLoader },
  data() {
    return {
      clients: [],
      tableColumns: ['id', 'name', 'redirect', 'active_tokens'],
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    this.clients = await CompanyCustomClientController.index();
    this.loading = false;
  },
  methods: {
    showClient(client_index) {
      let client = this.clients[client_index];
      this.$router.push({ name: 'Application Info', params: { client_id: client.id } });
    },
  },
};
</script>

<style scoped></style>
